import { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useNavigate } from 'react-router-dom'
import WTypography from '../../../../Components/whiteTypography'

function EAlimentationDonut({ reports, setHeaderValue, setOpen }) {
  const navigate = useNavigate()
  const [click, setClick] = useState(false)
  const [revData, setRevData] = useState({
    labels: ['Revenus salariaux', 'Revenus passifs', 'revenus autres'],
    datasets: [
      {
        data: [80, 5, 15],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    // maintainAspectRatio: false,
    aspectRatio: 1.3,
    clip: true,

    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value + '%']
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: false,
        events: [],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  function getRavData() {
    let groupName = []
    let amount = []
    let percentageAmount = []
    let sum = 0

    // storing the groups
    reports.length > 0 &&
      reports[0].byfoodcat.map((cat, i) => {
        groupName.push(cat.name)
        amount.push(cat.value)
        sum = sum + cat.value
      })

    // total amount for percentage
    let totalAmount = amount.reduce((a, b) => Math.abs(a) + Math.abs(b), 0)
    amount.map((v, i) => {
      if (v !== 0) {
        percentageAmount.push(((v * 100) / totalAmount).toFixed(0)) // removing decimal point
      }
    })

    groupName.length > 0 && setHeaderValue(sum.toFixed(2))
    setRevData({
      labels: groupName,
      datasets: [
        {
          // label: "Répartition revenus",
          data: percentageAmount,
          backgroundColor: [
            '#93b7ff',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
          ],
          borderColor: [
            '#93b7ff',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
            '#6087cd',
            '#295a9c',
          ],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }
  useEffect(() => {
    getRavData()
  }, [reports])

  const RevDoughnutChart = () => (
    <>
      {reports.length > 0 && reports[0].byfoodcat.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="8rem">
          Aucune donnée
          <WTypography variant="h6" onClick={() => setOpen(true)} align="center" marginTop="2rem">
            Répondre aux questionnaires pour estimer votre empreinte liée al'alimentation
          </WTypography>
        </WTypography>
      ) : (
        <Doughnut data={revData} options={optiondonut} />
      )}
    </>
  )

  return (
    <>
      <RevDoughnutChart />
    </>
  )
}

export default EAlimentationDonut
